var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { compile } from 'path-to-regexp';
var buildUrl = function (def, params) {
    try {
        var url = new URL(def);
        return url.origin + compile(def.replace(url.origin, ''))(params);
    }
    catch (e) {
        return compile(def)(params);
    }
};
var parseRoutes = function (routes) { return Object.keys(routes).reduce(function (acc, name) {
    var _a, _b;
    if (name in routes && typeof routes[name] === 'string') {
        return __assign(__assign({}, acc), (_a = {}, _a[name] = function (params) { return buildUrl(routes[name], params); }, _a));
    }
    else {
        return __assign(__assign({}, acc), (_b = {}, _b[name] = parseRoutes(routes[name]), _b));
    }
}, {}); };
var merge = function () {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    return (objects.reduce(function (result, current) {
        Object.keys(current).forEach(function (key) {
            if (typeof result[key] === 'object' && typeof current[key] === 'object') {
                result[key] = merge(result[key], current[key]);
            }
            else {
                result[key] = current[key];
            }
        });
        return result;
    }, {}));
};
var prependPrefixToRoute = function (definition, prefix) { return "".concat(prefix).concat(definition); };
var mergeDefs = function (collection, prefix) { return (Object.entries(collection).reduce(function (acc, _a) {
    var _b;
    var _c = __read(_a, 2), key = _c[0], value = _c[1];
    return (__assign(__assign({}, acc), (_b = {}, _b[key] = typeof value === 'string'
        ? typeof prefix === 'string'
            ? prependPrefixToRoute(value, prefix)
            : value
        : mergeDefs(value, (typeof prefix === 'object' && prefix !== null && key in prefix)
            ? prefix[key]
            : prefix), _b)));
}, {})); };
export var configure = function (_a) {
    var prefix = _a.prefix, modules = _a.modules;
    var paths = merge.apply(void 0, __spreadArray([], __read(modules), false));
    var defs = mergeDefs(paths, prefix);
    var routes = parseRoutes(defs);
    return {
        prefix: prefix,
        defs: defs,
        routes: routes,
    };
};
